import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminRoutingModule } from './admin-routing.module';
import { AdminComponent } from './admin/admin.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PoDetailsComponent } from './po-details/po-details.component';
import { HelpComponent } from './admin/help/help.component';
import { ProfileUpdateComponent } from './profile-update/profile-update.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { WorkingCapitalComponent } from './working-capital/working-capital.component';
import { CollectiveBuyingComponent } from './collective-buying/collective-buying.component';


import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { ReviewBiddingComponent } from './shared/pop-ups/review-bidding/review-bidding.component';
import { BiddingFinalConfirmationComponent } from './shared/pop-ups/bidding-final-confirmation/bidding-final-confirmation.component';
import { PartLevelDetailsComponent } from './shared/pop-ups/part-level-details/part-level-details.component';
import { RejectLiveRfqComponent } from './shared/pop-ups/reject-live-rfq/reject-live-rfq.component';
import { RejectPoComponent } from './shared/pop-ups/reject-po/reject-po.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AcceptPurchaseOrdersComponent } from './shared/pop-ups/accept-purchase-orders/accept-purchase-orders.component';
import { PoReadyToShipComponent } from './shared/pop-ups/po-ready-to-ship/po-ready-to-ship.component';
import { MatRadioModule } from '@angular/material/radio';
import { FillPartLevelCostComponent } from './shared/pop-ups/fill-part-level-cost/fill-part-level-cost.component';
import { MoveToInventoryComponent } from './shared/pop-ups/move-to-inventory/move-to-inventory.component';
import { MfgTermsConditionsComponent } from './shared/pop-ups/mfg-terms-conditions/mfg-terms-conditions.component';
import { RequestProfileUpdateComponent } from './shared/pop-ups/request-profile-update/request-profile-update.component';
import { BankDetailsComponent } from './shared/pop-ups/bank-details/bank-details.component';
import { PendingApprovalComponent } from './pending-approval/pending-approval.component';
import { RecordPoPaymentComponent } from './shared/pop-ups/record-po-payment/record-po-payment.component';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { MarkDeliveryProofComponent } from './shared/pop-ups/mark-delivery-proof/mark-delivery-proof.component';
import { EditAwbNumberComponent } from './shared/pop-ups/edit-awb-number/edit-awb-number.component';
import { CompanyAvatarComponent } from './shared/pop-ups/company-avatar/company-avatar.component';
import { UserAvatarComponent } from './shared/pop-ups/user-avatar/user-avatar.component';
import { DirectorAvatarComponent } from './shared/pop-ups/director-avatar/director-avatar.component';
import { EngageIntegrationComponent } from './shared/pop-ups/engage-integration/engage-integration.component';
import { TicketsComponent } from './tickets/tickets.component';
import { UpdateTicketComponent } from './tickets/update-ticket/update-ticket.component';
import { DeleteTicketComponent } from './tickets/delete-ticket/delete-ticket.component';
import { AddCommentComponent } from './tickets/add-comment/add-comment.component';

import { PaintingComponent } from './shared/pop-ups/painting/painting.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { CreateNewTicketComponent } from './tickets/create-new-ticket/create-new-ticket.component';
import { NotificationComponent } from './notification/notification.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { EngageRequestComponent } from './engage-request/engage-request.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { AppoinmentSuccessPopupComponent } from './engage-request/appoinment-success-popup/appoinment-success-popup.component';
import { MatTabsModule } from '@angular/material/tabs';
import { ProcureComponent } from './procure/procure.component';
import { ProcureAddQuoteComponent } from './procure/add-quote/add-quote.component';
import { ProcureEditQuoteComponent } from './procure/edit-quote/edit-quote.component';
import { ProcureViewOrderComponent } from './procure/view-order/view-order.component';
import { EditRmsBidComponent } from './procure/edit-rms-bid/edit-rms-bid.component';
import { UploadAndDownloadComponent } from './shared/pop-ups/upload-and-download/upload-and-download.component';
import { PdfViewerPopupComponent } from './pdf-viewer-popup/pdf-viewer-popup.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PinchZoomModule } from 'ngx-pinch-zoom';
import { QualityCheckComponent } from './shared/pop-ups/quality-check/quality-check.component';
import { UploadDocumentComponent } from './procure/upload-document/upload-document.component';
import { MatDialogModule } from '@angular/material/dialog';
import { UpdateBatchStageComponent } from './shared/pop-ups/update-batch-stage/update-batch-stage.component';
import { UpdateBatchTimelineComponent } from './shared/pop-ups/update-batch-timeline/update-batch-timeline.component';
import { ScheduleInspectionComponent } from './shared/pop-ups/schedule-inspection/schedule-inspection.component';
import { InspectionComponent } from './inspection/inspection.component';
import { AvatarModule } from 'ngx-avatar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UpdateBatchStageTimelinesComponent } from './shared/pop-ups/update-batch-stage-timelines/update-batch-stage-timelines.component';
import { ChecklistActionsComponent } from './shared/pop-ups/checklist-actions/checklist-actions.component';
import { MatButtonModule } from '@angular/material/button';
import { PaymentTermsConditionsComponent } from './shared/pop-ups/payment-terms-conditions copy/payment-terms-conditions.component';
import { ShipmentTermsConditionsComponent } from './shared/pop-ups/shipment-terms-conditions/shipment-terms-conditions.component';
import { SubmitCostingComponent } from './shared/pop-ups/submit-costing/submit-costing.component';
import { ChatAgreementComponent } from './shared/pop-ups/chat-agreement/chat-agreement.component';
import { ChatCadViewerComponent } from './shared/pop-ups/chat-cad-viewer/chat-cad-viewer.component';
import { OWL_DATE_TIME_FORMATS, OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';

export const MY_MOMENT_FORMATS = {
  parseInput: 'l LT',
  fullPickerInput: 'l LT',
  datePickerInput: 'l',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};
@NgModule({
  declarations:
    [
      AdminComponent,
      DashboardComponent,
      PoDetailsComponent,
      HelpComponent,
      ProfileUpdateComponent,
      WorkingCapitalComponent,
      CollectiveBuyingComponent,
      ReviewBiddingComponent,
      BiddingFinalConfirmationComponent,
      PartLevelDetailsComponent,
      RejectLiveRfqComponent,
      RejectPoComponent,
      AcceptPurchaseOrdersComponent,
      PoReadyToShipComponent,
      FillPartLevelCostComponent,
      MoveToInventoryComponent,
      MfgTermsConditionsComponent,
      RequestProfileUpdateComponent,
      BankDetailsComponent,
      PendingApprovalComponent,
      RecordPoPaymentComponent,
      MarkDeliveryProofComponent,
      EditAwbNumberComponent,
      CompanyAvatarComponent,
      UserAvatarComponent,
      DirectorAvatarComponent,
      EngageIntegrationComponent,
      TicketsComponent,
      UpdateTicketComponent,
      DeleteTicketComponent,
      AddCommentComponent,
      PaintingComponent,
      CreateNewTicketComponent,
      NotificationComponent,
      EngageRequestComponent,
      AppoinmentSuccessPopupComponent,
      ProcureComponent,
      ProcureAddQuoteComponent,
      ProcureEditQuoteComponent,
      ProcureViewOrderComponent,
      EditRmsBidComponent,
      UploadAndDownloadComponent,
      PdfViewerPopupComponent,
      QualityCheckComponent,
      UploadDocumentComponent,
      UpdateBatchStageComponent,
      UpdateBatchTimelineComponent,
      ScheduleInspectionComponent,
      InspectionComponent,
      UpdateBatchStageTimelinesComponent,
      ChecklistActionsComponent,
      PaymentTermsConditionsComponent,
      ShipmentTermsConditionsComponent,
      SubmitCostingComponent,
      ChatAgreementComponent,
      ChatCadViewerComponent
    ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AdminRoutingModule,
    FormsModule,
    AutocompleteLibModule,
    NgMultiSelectDropDownModule,
    MatMenuModule,
    MatCheckboxModule,
    MatSelectModule,
    MatOptionModule,
    MatInputModule,
    MatRadioModule,
    FileUploadModule,
    MatChipsModule,
    MatIconModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatDatepickerModule,
    MatTabsModule,
    PdfViewerModule,
    PinchZoomModule,
    MatDialogModule,
    MatTooltipModule,
    AvatarModule,
    MatButtonModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule
  ],
  exports: [MatChipsModule, MatIconModule],
  providers: [DatePipe, { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS }]
})
export class AdminModule { }
